<template>
    <zen-one
        :showuserinfo="false"
        :title="'Kutipan Pejabat Daerah'"
    >
        <z-animate-number value="29"></z-animate-number>
        <div class="headline m3">{{ $page.props.auth.user.jabatan_keterangan }}</div>
        <w-flex class="mb3">
            <w-card class="xs12">
                <table style="width: 100%" class="mb2 table-dashboard">
                    <thead>
                        <tr>
                            <th>Jenis Kutipan</th>
                            <th>HASIL CUKAI</th>
                            <th>HASIL BUKAN CUKAI</th>
                            <th>PELBAGAI HASIL</th>
                            <th>JUMLAH</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-row-data">
                            <td class="eis-daerah-table-data">Amaun</td>
                            <template v-for="item in tableData.rows">
                                <td class="eis-daerah-table-data">{{ item }}</td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </w-card>
        </w-flex>

        <w-flex class="grow justify-space-betweenx basis-zero">
            <w-card class="mb3 mr3">
                <div>
                    <w-flex class="justify-space-between">
                        <div class="dashboard-title">Kutipan Hasil Cukai</div>
                    </w-flex>
                    <fusioncharts
                        :type="chart6.type"
                        :width="chart6.width"
                        :height="chart6.height"
                        :dataformat="chart6.dataFormat"
                        :dataSource="chart6.dataSource"
                    >
                    </fusioncharts>
                </div>
            </w-card>

            <w-card class="mb3 mr3">
                <w-flex class="justify-space-between">
                    <div class="dashboard-title">KUTIPAN HASIL BUKAN CUKAI</div>
                </w-flex>
                <fusioncharts
                    :type="chart7.type"
                    :width="chart7.width"
                    :height="chart7.height"
                    :dataformat="chart7.dataFormat"
                    :dataSource="chart7.dataSource"
                >
                </fusioncharts>
            </w-card>
        </w-flex>

        <w-flex class="grow justify-space-betweenx basis-zero">
            <w-card class="mb3 mr3">
                <w-flex class="justify-space-between">
                    <div class="dashboard-title">
                        Kutipan Pelbagai Terimaan dan Pindahan
                    </div>
                </w-flex>
                <fusioncharts
                    :type="chart8.type"
                    :width="chart8.width"
                    :height="chart8.height"
                    :dataformat="chart8.dataFormat"
                    :dataSource="chart8.dataSource"
                >
                </fusioncharts>
            </w-card>
        </w-flex>
    </zen-one>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                apiBaseUrl: process.env.MIX_API_BASE_URL,
                tableData: {
                    columns: [],
                    rows: [],
                },
                chart6: {
                    type: "column2d",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            showvalues: "1",
                            xaxisname: "Jenis Kutipan Hasil",
                            yaxisname: "Jumlah Kutipan Hasil",
                            numberprefix: "RM",
                            theme: "fusion",
                        },
                        data: [],
                    },
                },
                chart7: {
                    type: "column2d",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            showvalues: "1",
                            xaxisname: "Jenis Kutipan Hasil",
                            yaxisname: "Jumlah Kutipan Hasil",
                            numberprefix: "RM",
                            theme: "fusion",
                        },
                        data: [],
                    },
                },
                chart8: {
                    type: "column2d",
                    width: "100%",
                    height: "350",
                    dataFormat: "json",
                    dataSource: {
                        chart: {
                            showvalues: "1",
                            xaxisname: "Jenis Kutipan Hasil",
                            yaxisname: "Jumlah Kutipan Hasil",
                            numberprefix: "RM",
                            theme: "fusion",
                        },
                        data: [],
                    },
                },
            };
        },
        methods: {
            async fetchData() {
                this.loading = true;
                await axios
                    .get(`${this.apiBaseUrl}/dashboard/eis-daerah`,{
                        params: {
                            jabatan_id : this.$page.props.auth.user.jabatan_id
                        }
                    })
                    .then((resp) => {
                        const { table, barChart } = resp.data;
                        this.tableData.rows = table.rows;
    
                        this.chart6.dataSource.data = barChart.hasil_cukai;
                        this.chart7.dataSource.data = barChart.hasil_pelbagai;
                        this.chart8.dataSource.data = barChart.hasil_bukan_cukai;
                    })
                    .catch((err) => {
                        console.error(err);
                    });
                this.loading = false;
            },
        },
        mounted() {
            this.fetchData();
        },
    };
    </script>

<style>
    .eis-daerah-table-overflow {
        overflow: auto;
    }
    
    .eis-daerah-table-data:nth-child(1) {
        font-weight: bold;
    }
    
    .eis-daerah-table-data:nth-child(2n + 2) {
        background-color: rgba(247, 110, 17, 0.6);
    }
    .eis-daerah-table-data:nth-child(2n + 3) {
        background-color: rgba(255, 159, 69, 0.6);
    }
</style>
